IREP.facetoface = (function () {
    "use strict";

    var init = function (cultureCode) {
       
        this.options = {apiRoot : window.location.origin + "/50/"};
        
        if (cultureCode == "pt-BR") {
            $("#logo").css({ "background": "url(" + IREP.options.appUrl + "content/images/nav/logo_pt-br.png) center no-repeat" });
        }

        $("#alreadyAMember").click(function () {
            $("#inputDiv").hide();
            $("#signin").show();
        });

        $("#backtoSignup").click(function () {
            $("#inputDiv").show();
            $("#signin").hide();
        });


        $("#loginCode").click(function () {
                        
            if (validLogin()) {
                var data = {
                    password: $("#password").val(),
                    username: $("#username").val()
                };


                IREP.callApi({
                    url: "auth/login",
                    data: data,
                    type: "POST"
                }).done(function (data) {
                    if (data.isValid) {
                        IREP.callApi({
                            url: "fieldsignup/lookup",
                            data: {
                                eventCode: $("#code2").val(),
                            }
                        }).done(function (event) {
                            
                            if (event.eventInfo != null) {

                                $("#takeTheQuiz").attr({ "data-paxUID": data.userData.currentUID });
                                $("#eventName").html(event.eventInfo.event);
                                $("#takeTheQuiz").attr({ "data-quizCode": event.eventInfo.activityCode });
                                $("#inputDiv").hide();
                                $("#signin").hide();
                                $("#takeTheQuizDiv").show();
                                $("#inputWrapper").width("600px");                            
                            } else {
                                $(".badEventCode").show();
                            }
                        });
                    }
                });
            }
        });

        $("#submitCode").click(function () {
            $(".error").remove();
            $(".errorMessage").hide();
            if (isValid()) {
                
                var data = {
                    eventCode: $("#code").val(),
                    firstName: $("#firstname").val(),
                    lastName: $("#lastname").val(),
                    email: $("#email").val()
                };
                

                IREP.callApi( { url: "fieldsignup/enterCode",
                    data: data
                }).done(function (data) {
                    if (data.fieldSignUpParticipant.activityId > 0) {
                        $("#eventName").html(data.fieldSignUpParticipant.event);
                        $("#takeTheQuiz").attr({ "data-quizCode": data.fieldSignUpParticipant.activityCode });
                                                
    
                        var d = JSON.stringify({
                            geo: data.fieldSignUpParticipant.geoCode,
                            country: data.fieldSignUpParticipant.countryCode,
                            language: data.fieldSignUpParticipant.cultureCode,
                            usertype: (data.fieldSignUpParticipant.storeChainType == 247 ? 246 : 67 ),
                            employeeCode: '',
                            firstname: $("#firstname").val(),
                            lastname: $("#lastname").val(),
                            address1: '',
                            address2: '',
                            city: '',
                            province: '',
                            postal: '',
                            phone: '',
                            cellphone: '',
                            email: $("#email").val(),
                            password: $("#code").val()+'1a.',
                            company: data.fieldSignUpParticipant.storeId,
                            position: 47,
                            displayName: 1,
                            shareInfo: 1,
                            receiveEmail: 1,
                            receiveText: 0,
                            allowSurvey: 1,
                            allowFocus: 1,
                            memberDir: 1,
                            recruitedBy: '',
                            storeName: '',
                            storeAddress1: '',
                            storeAddress2: '',
                            storeCity: '',
                            storePostal: '',
                            storePhone: '',
                            shirtSize: '',
                            qstSignUp: 1,
                            mobile: ''
                        });

                
                        $.ajax({
                            type: "POST",
                            url: "../ws/registration.asmx/Register",
                            contentType: "application/json; charset=utf-8",
                            data: d,
                            dataType: "json",
                            dataFilter: function (msg) {
                                msg = eval('(' + msg + ')');
                                if (msg.hasOwnProperty('d'))
                                    return msg.d;
                                else
                                    return msg;
                            },
                            success: function (msg) {                                
                                if (msg.IsValid == true) {
                                    $("#takeTheQuiz").attr({ "data-paxUID": msg.Text });
                                    $("#inputDiv").hide();
                                    $("#takeTheQuizDiv").show();
                                    $("#inputWrapper").width("600px");
                                } else {
                                    $(".genericError").show();
                                    return;
                                }
                            },
                            error: function (msg) {
                                $(".genericError").show();
                                return;
                            }
                        });

                    } else if (data.fieldSignUpParticipant.activityId == -1) {
                        $(".badEventCode").show();
                    } else if (data.fieldSignUpParticipant.activityId == -2) {
                        $("#inputDiv").hide();
                        $("#signin").show();
                        $("#code2").val($("#code").val());
                        $("#username").val($("#email").val());
                    }
                });
            }
        });
    };

    var validLogin = function () {
        var isValid = true;

        if ($("#username").val() === "") {
            $("#username").before("<span class='error'> * </span>");
            isValid = false;
        }
        if ($("#password").val() === "") {
            $("#password").before("<span class='error'> * </span>");
            isValid = false;
        }
        return isValid;
    }

    var isValid = function () {
        var isValid = true;

        if ($("#firstname").val() === "") {
            $("#firstname").before("<span class='error'> * </span>");
            isValid = false;
        }
        if ($("#lastname").val() === "") {
            $("#lastname").before("<span class='error'> * </span>");
            isValid = false;
        }
        if ($("#email").val() === "") {
            $("#email").before("<span class='error'> * </span>");
            isValid = false;
        }
        if ($("#code").val() === "") {
            $("#code").before("<span class='error'> * </span>");
            isValid = false;
        }
        return isValid;
    };

    $("#takeTheQuiz").click(function () {
        window.location = "/50/emea/quiz?code=" + $("#takeTheQuiz").attr("data-quizCode") + "&redirectid=" + 13 + "&paxuid=" + $("#takeTheQuiz").attr("data-paxUID")+"&start=1";
    });


    return {
        init: init
    };
})();